import {
  SET_STUDENT,
  SET_STUDENT_POSITION,
  SET_STUDENT_NEXT_POSITION,
  SET_TELEMETRY_DATA,
  SET_STUDENT_CURRENT_CC,
  SET_MODULE_SOUNDS,
  RESET_PROGRESS,
  RESET_STUDENT,
  SET_SHOW_CLOSED_CAPTIONS
} from '../types/student';

import { showSpinner, hideSpinner } from './ui';
import Api from 'utils/api';

export const setStudentData = data => ({ type: SET_STUDENT, payload: data });
export const setStudentPosition = data => ({ type: SET_STUDENT_POSITION, payload: data });
export const setStudentNextPosition = data => ({ type: SET_STUDENT_NEXT_POSITION, payload: data });
export const setTelemetryData = data => ({ type: SET_TELEMETRY_DATA, payload: data });
export const setModuleSounds = data => ({ type: SET_MODULE_SOUNDS, payload: data });
export const setShowClosedCaptions = value => ({
  type: SET_SHOW_CLOSED_CAPTIONS,
  payload: value
});
export const resetStudentData = () => ({ type: RESET_STUDENT });
export const resetProgress = () => ({ type: RESET_PROGRESS });

export const getCurrentPosition = () => async (dispatch, getState) => {
  const {
    student: { currentPosition },
    ui: { module }
  } = getState();

  dispatch(showSpinner());
  const { status, data } = await Api.get('/students/me/progress', { module });

  dispatch(hideSpinner());
  if (status < 400) {
    const { characterOrder, freePlay, groups, audio: moduleSound } = data;
    dispatch(setTelemetryData({ characterOrder, freePlay }));
    dispatch(setModuleSounds({ moduleSound }));
    if (!currentPosition || currentPosition.length === 0) {
      dispatch(setStudentPosition(groups));
    } else dispatch(setStudentNextPosition(groups));
  }
};

export const updateStudentPosition = () => (dispatch, getState) => {
  const {
    student: { nextPosition }
  } = getState();
  dispatch(setStudentPosition(nextPosition));
};

export const setCurrentCaption = caption => ({ type: SET_STUDENT_CURRENT_CC, payload: caption });
